/* eslint-disable prefer-template */
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import DropdownItem from '../dropdown/dropdown-item';
import Input from '../input';
import './mentions-input.scss';

const MentionsInput = ({
  label, placeholder, className, onChange, triggerChar, value, recommendation,
  renderIconForEachRecommendations,
}) => {
  const [showRecommendation, setShowRecommendation] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const cursorPosition = useRef();

  const emailRegex = new RegExp(`\\${triggerChar}\\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}\\b`, 'g');

  useEffect(() => {
    if (recommendation) {
      setShowRecommendation(true);
    }
  }, [recommendation]);

  const getCurrentFocusedWord = (input, cursorPositioning) => {
    const trimmedInput = input?.trim();

    const updatedTrimmedInput = trimmedInput?.substring(0, cursorPositioning);
    const lastSpaceIndex = updatedTrimmedInput?.lastIndexOf(' ');
    const lastWordPositionInTrimmedInput = lastSpaceIndex === -1 ? 0 : lastSpaceIndex + 1;

    const nextSpaceIndex = trimmedInput?.indexOf(' ', lastWordPositionInTrimmedInput);
    const lastWordEndIndex = nextSpaceIndex === -1 ? trimmedInput.length : nextSpaceIndex;
    const lastWord = trimmedInput?.substring(lastWordPositionInTrimmedInput, lastWordEndIndex);

    if (input[cursorPositioning - 1] === ' ' || lastWord.trim() === '') {
      return { currentWord: ' ', wordPosition: lastWordPositionInTrimmedInput };
    }

    return { currentWord: lastWord, wordPosition: lastWordPositionInTrimmedInput };
  };

  const triggerCharIndex = (input) => input?.indexOf(triggerChar);

  const getSearchQueryParams = (currentWord) => {
    if (currentWord && currentWord.includes(triggerChar)) {
      const triggerCharPositioning = triggerCharIndex(currentWord);
      const queryToSearch = currentWord.slice(triggerCharPositioning + 1);
      setShowRecommendation(true);
      return queryToSearch;
    }
    setShowRecommendation(false);
    return '';
  };

  const update = (e, updatedText) => {
    const text = updatedText || e.target.value;
    setInputValue(text);

    const { selectionStart } = e ? e.target : updatedText;
    cursorPosition.current = selectionStart;

    const emailsInText = text?.match(emailRegex)?.map((email) => email.substring(1)) ?? [];

    const { currentWord } = getCurrentFocusedWord(text, selectionStart);

    let searchQuery = !emailRegex.test(currentWord) && getSearchQueryParams(currentWord);

    if (searchQuery) {
      searchQuery = searchQuery.replace(/[\u{0080}-\u{FFFF}]/gu, '');
    }
    // eslint-disable-next-line no-console
    console.log('MentionInput Search Query', searchQuery);

    onChange({ text, emails: emailsInText, q: searchQuery });
  };

  const handleItemClick = (itemId) => {
    const dropdownSelectedValue = recommendation?.filter((item) => item?.id === itemId);

    const { currentWord, wordPosition } = getCurrentFocusedWord(inputValue, cursorPosition.current);
    const triggerCharPosition = triggerCharIndex(currentWord);

    getSearchQueryParams(currentWord);

    const updatedValue = inputValue.slice(0, wordPosition + triggerCharPosition + 1)
      + dropdownSelectedValue[0].email
      + ' '
      + inputValue.slice(currentWord.length + wordPosition);

    setInputValue(updatedValue);
    setShowRecommendation(false);

    update(undefined, updatedValue);
  };

  return (
    <div className={clsx('mentions-input', { [className]: className })}>
      {label && (
        <div className="input-label">
          {label}
        </div>
      )}
      <div className="input-cont">
        <Input
          onChange={(e) => update(e)}
          placeholder={placeholder}
          value={inputValue}
          autoFocus
          multiline
        />
        {showRecommendation && (
          <div className="recommendations-dropdown">
            {recommendation?.map((item) => (
              <DropdownItem
                key={item?.id}
                label={item?.email}
                items={recommendation}
                onClick={() => handleItemClick(item?.id)}
                showDivider
                renderIcon={renderIconForEachRecommendations
                  ? () => renderIconForEachRecommendations({ item }) : undefined}
              />
            ))}
          </div>
        )}
      </div>

    </div>
  );
};

MentionsInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  triggerChar: PropTypes.string,
  recommendation: PropTypes.arrayOf(PropTypes.shape({})),
  renderIconForEachRecommendations: PropTypes.func,
};

MentionsInput.defaultProps = {
  className: '',
  label: '',
  value: '',
  onChange: () => { },
  placeholder: '',
  triggerChar: '@',
  recommendation: [],
  renderIconForEachRecommendations: null,
};

export {
  MentionsInput as default,
};
